module.exports = __webpack_public_path__ + "img/white-x.97833173.svg";